export default {
    setACL(state, acl) {
        state.acl = acl;
    }
};
